/* ==========================================================================
   PN 2.43 — 31.08.2026
   Koleksiyon hizli filtre baloncuklari — davranis.

   HICBIR DUGUM TASINMAZ. FILTRELE baloncugu, gecerli kirilma noktasindaki
   facet cekmecesinin <summary>'sini tiklar:
     mobil   (<750px) : facet-drawer.mobile-facets__wrapper > details > summary
     masaustu(>=750px): facet-drawer#FacetDrawer     > details > summary

   MenuDrawer.onSummaryClick (assets/global.js) isTrusted kontrolu yapmaz ve
   durumu details[open] uzerinden okur, bu yuzden sentetik click calisir.
   Gizli bir <summary> de tiklanabilir.

   Cekmece acilirken odagi calmayiz: MenuDrawer.onFocusOut acik <details>
   disina cikan odakta cekmeceyi kapatiyor.
   ========================================================================== */
(function () {
  'use strict';

  var DESKTOP = '(min-width: 750px)';

  function currentSummary() {
    var desktop = window.matchMedia(DESKTOP).matches;
    var sel = desktop
      ? 'facet-drawer#FacetDrawer > details > summary'
      : 'facet-drawer.mobile-facets__wrapper > details > summary';
    var el = document.querySelector(sel);
    if (el) return el;
    // Kirilma noktasi beklenmedikse digerini dene.
    return document.querySelector(
      desktop
        ? 'facet-drawer.mobile-facets__wrapper > details > summary'
        : 'facet-drawer#FacetDrawer > details > summary'
    );
  }

  function bindFilterChip(root) {
    var btn = root.querySelector('[data-pn-chips-open]');
    if (!btn || btn.dataset.pnBound) return;

    /* Urun izgarasi olmayan sablonlarda (-tum-urunler ailesi) facet cekmecesi
       hic basilmiyor. O sayfalarda FILTRELE dugmesi hicbir sey acamaz; olu
       bir dugme birakmak yerine gizle. */
    if (!currentSummary()) {
      btn.hidden = true;
      btn.setAttribute('aria-hidden', 'true');
      return;
    }

    btn.dataset.pnBound = '1';

    btn.addEventListener('click', function (event) {
      event.preventDefault();
      var summary = currentSummary();
      if (!summary) return;
      summary.click();
    });
  }

  function syncFade(root) {
    var row = root.querySelector('[data-pn-chips-row]');
    if (!row) return;
    var overflowing = row.scrollWidth - row.clientWidth > 2;
    var atEnd = row.scrollLeft + row.clientWidth >= row.scrollWidth - 2;
    if (overflowing && !atEnd) {
      root.removeAttribute('data-pn-chips-nofade');
    } else {
      root.setAttribute('data-pn-chips-nofade', '');
    }
  }

  /* "Cok satan" siralamasi adres satirindaki sort_by ile geliyor; Liquid
     bunu goremez, aktiflik burada isaretlenir. Tekrar tiklanirsa siralama
     kalkar. */
  function syncSortChip(root) {
    var chip = root.querySelector('[data-pn-chip-sort]');
    if (!chip) return;
    var current = null;
    try {
      current = new URLSearchParams(window.location.search).get('sort_by');
    } catch (e) {
      return;
    }
    var isActive = current === chip.getAttribute('data-pn-chip-sort');
    chip.classList.toggle('pn-chip--active', isActive);
    if (isActive) {
      chip.setAttribute('aria-current', 'true');
      var off = chip.getAttribute('data-pn-chip-off');
      if (off) chip.setAttribute('href', off);
    } else {
      chip.removeAttribute('aria-current');
    }
  }

  function init() {
    var roots = document.querySelectorAll('[data-pn-chips]');
    if (!roots.length) return;

    Array.prototype.forEach.call(roots, function (root) {
      bindFilterChip(root);
      syncSortChip(root);
      syncFade(root);

      var row = root.querySelector('[data-pn-chips-row]');
      if (row && !row.dataset.pnScrollBound) {
        row.dataset.pnScrollBound = '1';
        row.addEventListener(
          'scroll',
          function () {
            syncFade(root);
          },
          { passive: true }
        );
      }

      if ('ResizeObserver' in window && row && !root.dataset.pnRo) {
        root.dataset.pnRo = '1';
        new ResizeObserver(function () {
          syncFade(root);
        }).observe(row);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.addEventListener('resize', function () {
    var roots = document.querySelectorAll('[data-pn-chips]');
    Array.prototype.forEach.call(roots, syncFade);
  });

  document.addEventListener('shopify:section:load', init);
})();
